// extracted by mini-css-extract-plugin
module.exports = {"benefitList":"BenefitsList_benefitList__3KTb-","benefit":"BenefitsList_benefit__3F_yP"};